import { TypedAction } from '@ngrx/store/src/models';

export abstract class Validator<T> {
  constructor(protected data: T) {}

  public abstract validate(): TypedAction<any>;
}
